import { CSSProperties, FC, ReactNode } from 'react';

export type DynamicHeadingProps = {
  isMainHeading: boolean;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

export const DynamicHeading: FC<DynamicHeadingProps> = ({
  isMainHeading,
  className,
  children,
  style,
}) => {
  const HeadingTag = isMainHeading ? 'h1' : 'h2';
  return (
    <HeadingTag className={className} style={style}>
      {children}
    </HeadingTag>
  );
};
